<template>
    <div class="view" :style="{paddingTop:navbarheight}">
        <div class="content">
            <my-top title="食堂用餐" lefttext="提交" @leftclick="togo('/application/canteen/dinersNum')" :righttext="!readonly ? subTit : ''" @rightclick="handleValidator"></my-top>
            <Form ref="form">
                <cell-group class="baseInfo">
                    <cell title="单位" :value="form.unitName"></cell>
                    <cell class="timeCell" title="用餐日期" is-link :value="form.createTime" @click="visible= ableVisible ? !ableVisible : !visible"></cell>
                </cell-group>
                <cell-group title="用餐明细" class="cellgroup">
                    <field @input="handleAllMoney()" :rules="[{required: true}]" :readonly="readonly" v-model="info.breakfast" label="早餐人数" type="digit" placeholder="请输入" />
                    <field @input="handleAllMoney()" :rules="[{required: true}]" :readonly="readonly" v-model="info.lunch" label="中餐人数" type="digit" placeholder="请输入" />
                    <field @input="handleAllMoney()" :rules="[{required: true}]" :readonly="readonly" v-model="info.dinner" label="晚餐人数" type="digit" placeholder="请输入" />
                    <field @input="handleAllMoney()" :rules="[{required: true}]" readonly v-model="numForm.breakfastMoney" label="早餐金额（元）" type="number" placeholder="自动计算" />
                    <field @input="handleAllMoney()" :rules="[{required: true}]" readonly v-model="numForm.lunchMoney" label="中餐金额（元）" type="number" placeholder="自动计算" />
                    <field @input="handleAllMoney()" :rules="[{required: true}]" readonly v-model="numForm.dinnerMoney" label="晚餐金额（元）" type="number" placeholder="自动计算" />
                    <field @input="handleAllMoney()":rules="[{required: true}]"  v-model="form.dayMoney" label="日合计（元）" type="number" placeholder="自动计算" />
                </cell-group>
            </Form>
        </div>
        <Popup v-model="visible" position="bottom">
            <datetime-picker
                    v-model="mealTime"
                    type="date"
                    title="选择年月日"
                    :formatter="formatter"
                    :max-date="maxDate"
                    @confirm="handleDate"
                    @cancel="visible=false"
            />
        </Popup>

    </div>
</template>

<script>
    import {Cell, CellGroup, DatetimePicker, Dialog, Field, Form, Icon, Popup} from 'vant';
    import application from '@api/application';
    import { useStandFee } from '../hooks'

    export default {
        name: "dinersForm",
        components: {Cell, CellGroup, Field, Icon, DatetimePicker, Popup,Form, Dialog},
        data(){
            return{
                visible:false,
                ableVisible:true,
                subBtn:true,
                subTit:'提交',
                orgname:JSON.parse(localStorage.getItem("vuex")).user.posts.oname,
                listId:this.$route.query.listId,
                readonly:this.$route.query.readonly || false,
                maxDate: new Date(),
                mealTime: new Date(),
                form:{
                    createTime: this.formatDate(new Date()),
                    unitId: JSON.parse(localStorage.getItem("vuex")).user.company.id,
                    unitName: JSON.parse(localStorage.getItem("vuex")).user.company.name,
                    orgId: JSON.parse(localStorage.getItem("vuex")).user.company.deptId,
                    dayMoney: null //日合计
                },
                info:{
                    breakfast: null, //早餐人数
                    lunch: null, //午餐人数
                    dinner: null, //晚餐人数
                },
                numForm:{
                    breakfastMoney: null,//早餐金额
                    lunchMoney: null,//午餐金额
                    dinnerMoney: null,//晚餐金额
                }
            }
        },
        methods:{
            formatter(type, val) {
                if (type === 'year') {
                    return `${val}`;
                } else if (type === 'month') {
                    return `${val}`;
                }else if (type === 'day') {
                    return `${val}`;
                }
                return val;
            },
            /**
             * 选择采集日期
             **/
            handleDate(e){
                this.form.createTime = this.formatDate(e);
                this.visible = false;
                this.handleSureDate(e)
            },
            handleSureDate(e){
                let id;
                if(e){
                    id = this.formatDate(e)
                }else {
                    id = this.formatDate(new Date())
                }
                let form ={
                    id:id,
                    orgId: JSON.parse(localStorage.getItem("vuex")).user.company.deptId,
                }
                application.getOfficeCanteenPeopleByTime(form).then(res => {
                    //0:未采集；1：已采集
                    if(res.code == 0){
                        if(res.data.time == 1){
                            this.readonly = true;
                            Dialog.confirm({
                                message: '该日期已提交数据，不可重复提交',
                            })
                        }else if(res.data.time == 0) {
                            this.readonly = false;
                        }
                    }
                })
            },
            /**
             * 总计
             * 早/午/晚餐金额：早/午/晚餐人数*餐标
             **/
            handleAllMoney(){
                const standFee = useStandFee() // 当前岗位对应级别的餐标
                this.form.dayMoney=null;
                this.numForm.breakfastMoney = this.info.breakfast * standFee[0] || null;
                this.numForm.lunchMoney = this.info.lunch * standFee[1] || null;
                this.numForm.dinnerMoney = this.info.dinner * standFee[2] || null;
                for(let i in this.numForm){
                    if(this.numForm[i]){
                        this.form.dayMoney +=this.numForm[i]
                    }
                }
            },
            /**
             * 表单必填验证
             **/
            handleValidator() {
                if(!this.subBtn){
                    this.$toast('正在提交，请稍后再试！')
                    return false
                }
                let form = {...this.info, ...this.numForm},
                    status=true;
                for(let i in form){
                    if(!form[i]){
                        status = false;
                        this.$toast('请完成用餐明细填写');
                        break;
                    }
                }
                if(status){
                    Dialog.confirm({
                        message: '请确认是否要提交，提交后不可修改。',
                    }).then(() => {
                        this.handleSubmit()
                        })
                }
            },
            /**
             * 表单提交
             **/
            handleSubmit(){
                this.subBtn = false;
                this.subTit = '正在提交';
                this.form.mealTime = this.formatDate(this.mealTime);
                application.addCanteenPeopleSelective({...this.form, ...this.info, ...this.numForm}).then(res => {
                    if(res.code == 0 ){
                        this.$router.push({
                            path: '/application/canteen/dinersNum',
                        })
                    }
                    this.subTit = '提交';
                    this.subBtn = true;
                }).catch(err => {
                    this.subTit = '提交';
                    this.subBtn = true;
                    this.$toast('提交失败'+err)
                })
            },
            /**
             * 获取表单信息
             **/
            handleGetInfo(){
                application.getCanteenPeople({id:this.listId}).then(res => {
                    if(res.code == 0){
                        for(let i in this.form){
                            this.form[i] = res.data[i]
                        }
                        for(let i in this.info){
                            this.info[i] = res.data[i]
                        }
                        for(let i in this.numForm){
                            this.numForm[i] = res.data[i]
                        }
                    }
                }).catch(err => {
                    this.$toast('获取失败'+err)
                })
            },
        },
        mounted(){
            if(this.readonly){
                // 从详情进入，则不能切换采购日期；
                this.ableVisible = true;
                this.handleGetInfo()
            }else {
                // 提交食堂采购进入，可切换采购日期；
                this.ableVisible = false;
                this.handleSureDate()
            }
        }
    }
</script>

<style lang="scss" scoped>
    ::v-deep .van-cell-group__title{
        background-color: #f2f2f2;
    }
    ::v-deep .van-field__label{
        flex: 1;
    }
    .baseInfo{
        ::v-deep .van-cell__title{
            flex: 0.5;
        }
        .timeCell{
            ::v-deep .van-icon{
                padding-top: 5px;
            }
        }
    }
    ::v-deep .van-field__control{
        text-align: right;
    }
    ::v-deep .navbar .van-nav-bar__right .van-nav-bar__text{
        color: #018fe0;
    }
    .confirmPop{
        width: 80%;
        padding: 2rem 1rem 1rem;
        button{
            margin-top: 1rem;
            padding: 0.5rem 3rem;
        }
    }


</style>